// =============================================================================
// Scrollpoints Module
// =============================================================================

// Notes:           Fire in bundle on a needed event. No events inside here.

import _Modules from '../core/core--modules';

export default new _Modules({
    name: 'Scrollpoints',
    settings: {
        scrollpoint: null,
        elementOffset: null, // By ID for now only
        offset: 0,
        direction: 'both',
        debug: false,
        menu: false,
        menuTitle: false
    },
    fn() {
        const _module = this;
        const { settings } = _module;
        const { scrollpoint, offset, elementOffset, direction, menu, menuTitle, debug } = settings;

        const getCurrentScrollpoint = () => {
            let scrollpointsArr = document.querySelectorAll(scrollpoint);
            scrollpointsArr = [...scrollpointsArr];

            const scrollpointsArrWithActive = scrollpointsArr.map(item => {
                const elementOuterHeight = document.getElementById(elementOffset) ? document.getElementById(elementOffset).offsetHeight : 0;

                const totalOffset = elementOuterHeight || offset;
                const spFromTop = item.offsetTop - totalOffset;
                const spHeight = item.offsetHeight;
                const amountScrolled = window.pageYOffset;
                const trigger = amountScrolled + totalOffset;

                // Conditions
                const spTouchesTrigger = amountScrolled >= spFromTop;
                const spNotPassedTrigger = amountScrolled < spFromTop + spHeight;
                const triggerMatching = spTouchesTrigger && spNotPassedTrigger;
                let isActive = false;

                if (direction === 'both') {
                    triggerMatching ? (isActive = true) : (isActive = false);
                }
                if (direction === 'down') {
                    spTouchesTrigger ? (isActive = true) : (isActive = false);
                }
                let elementTrigger;
                if (debug) {
                    elementTrigger = document.getElementsByClassName('scrollpoint__trigger');
                    if (elementTrigger) {
                        const trigger = amountScrolled + trigger;
                        elementTrigger[0].style.top = `${trigger}px`;
                    }
                }

                // Menu
                let name = null;
                let nameAlt = null;
                if (menu && menuTitle) {
                    const menuTitleEl = $(item).find(menuTitle);
                    name = menuTitleEl.text().trim();
                    nameAlt = menuTitleEl.data('title-alt') || menuTitleEl.data('title-alt');
                }
                return {
                    ...(name && { name: nameAlt || name }), // Add menu name conditionally
                    id: item.id,
                    isActive
                };
            });

            return new Promise((resolve, reject) => {
                if (Array.isArray(scrollpointsArrWithActive) && scrollpointsArrWithActive.length) {
                    resolve(scrollpointsArrWithActive);
                } else {
                    const why = "Can't get scrollpoints for some reason. First check your selectors";
                    reject(why);
                }
            });
        };

        return {
            get() {
                return getCurrentScrollpoint();
            }
        };
    }
});
